import React from 'react';
import PropTypes from 'prop-types';

const LongArrowLeftSvg = function LongArrowLeftSvg(props) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    props,
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0.15863 12.3826L5.61305 17.8103C5.80898 18.0379 6.15332 18.0645 6.38211 17.8695C6.6109 17.6745 6.63758 17.3318 6.4416 17.1042C6.42332 17.083 6.40344 17.0631 6.38211 17.045L1.8604 12.54L23.4546 12.54C23.7558 12.54 24 12.297 24 11.9972C24 11.6975 23.7558 11.4545 23.4546 11.4545L1.8604 11.4545L6.38211 6.95501C6.6109 6.76004 6.63758 6.4174 6.4416 6.18973C6.24562 5.96206 5.90132 5.93552 5.67253 6.13054C5.6512 6.14873 5.63128 6.16851 5.61305 6.18973L0.158583 11.6174C-0.0528679 11.829 -0.052866 12.1709 0.15863 12.3826Z',
      fill: '#2D34B2',
    })
  );
};

LongArrowLeftSvg.defaultProps = {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

const LongArrowRightSvg = function LongArrowRightSvg(props) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    props,
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.8414 11.6174L18.387 6.18973C18.191 5.96206 17.8467 5.93552 17.6179 6.13054C17.3891 6.32551 17.3624 6.66815 17.5584 6.89582C17.5767 6.91705 17.5966 6.93687 17.6179 6.95501L22.1396 11.46H0.545428C0.244214 11.46 0 11.703 0 12.0028C0 12.3025 0.244214 12.5455 0.545428 12.5455H22.1396L17.6179 17.045C17.3891 17.24 17.3624 17.5826 17.5584 17.8103C17.7544 18.0379 18.0987 18.0645 18.3275 17.8695C18.3488 17.8513 18.3687 17.8315 18.387 17.8103L23.8414 12.3826C24.0529 12.171 24.0529 11.8291 23.8414 11.6174Z',
      fill: 'var(--primary-color)',
    })
  );
};

LongArrowRightSvg.defaultProps = {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

function CustomPagination({ totalPages, page, onPrev, onNext, disableNext }) {
  return (
    <div>
      {page} / {totalPages}{' '}
      <button
        style={{
          cursor: 'pointer',
          margin: '0.6rem',
          border: 'none',
          backgroundColor: 'transparent',
        }}
        onClick={onPrev}
        disabled={page === 1}
      >
        <LongArrowLeftSvg />
      </button>{' '}
      <button
        style={{
          cursor: 'pointer',
          margin: '0.6rem',
          border: 'none',
          backgroundColor: 'transparent',
        }}
        onClick={onNext}
        disabled={disableNext}
      >
        <LongArrowRightSvg />
      </button>
    </div>
  );
}

CustomPagination.propTypes = {
  page: PropTypes.number,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  totalPages: PropTypes.number,
  disableNext: PropTypes.bool,
};

export default CustomPagination;
